import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {BaseSubFormComponent} from "../../../umbrella-common/components/base-sub-form.component";
import {getProcessTypeForStandard, Order, ProcessType, Product, StandardName} from "../../../store/state/order.state";
import {FormGroup} from "@angular/forms";
import {TransferDetailsFormService} from "./transfer-details-form-service";
import {TransferAuditDatesValidatorsService} from "./transfer-audit-dates-validators.service";
import {TranslationsHelperService} from "../../translations/translations-helper.service";

@Component({
    selector: 'transfer-details',
    templateUrl: './transfer-details.template.html',
    styleUrls: ['./transfer-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TransferDetailsComponent extends BaseSubFormComponent implements OnInit {

	@Input() order: Order;
	@Input() product: Product;
	@Input() translateClientsData: boolean;

	form: FormGroup;

	nonConformitiesNumbers: number[] = [];
	isOpenNonConformities: boolean;

	constructor(private formService: TransferDetailsFormService, private transferAuditDatesValidatorsService: TransferAuditDatesValidatorsService, public translationsHelper: TranslationsHelperService) {
		super(formService);
		for (let i = 0; i < 100; i++) {
			this.nonConformitiesNumbers.push(i);
		}
	}

	ngOnInit() {
		this.form = this.formService.buildSubForm(this.product.standard.name, this.totalSubForms(this.order), this.product);
		this.isOpenNonConformities = this.product.additionalQuestions.transferQuestions.hasOpenNonConformities;
	}

	get standardName(): StandardName {
		return this.product.standard.name;
	}

	getFormKey(): string {
		return this.standardName;
	}

	autoGrow(element: HTMLTextAreaElement) {
		if (element.scrollHeight > element.clientHeight) {
			element.style.height = element.scrollHeight + 'px';
		}
	}

	updateDateFormControlAndValidateAllDates(dateFormControlName: string, value: any) {
		this.formService.updateFormControl(dateFormControlName, value, this.getFormKey());
		this.formService.triggerValidationsFor(this.getFormKey(), 'lastAuditPerformedDate');
		this.formService.triggerValidationsFor(this.getFormKey(), 'expirationDate');
	}

	get expirationDateIsInPastOrClose(): boolean {
		return this.transferAuditDatesValidatorsService.expirationDateIsInPastOrClose(this.expirationDate);
	}

	get lastAuditPerformedDate(): Date {
		return this.product.additionalQuestions.transferQuestions.lastAuditPerformedDate;
	}

	get expirationDate(): Date {
		return this.product.additionalQuestions.transferQuestions.expirationDate;
	}

	shouldDisableRadio(controlName: string): boolean {
		const formControl = this.formService.getFormControl(this.product.standard.name, controlName);
		return formControl && formControl.disabled;
	}

	onConfirmitiesChange(value: boolean) {
		this.isOpenNonConformities = value;
	}

	override totalSubForms(order: Order): number {
		return order.products.filter(p => getProcessTypeForStandard(p.standard) == ProcessType.TRANSFER).length;
	}

	protected iso27701HasItsOwnSubForm(): boolean {
		return true;
	}
}
